



























































import Vue from 'vue'
import Hammer from 'hammerjs'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { Component, Watch } from 'vue-property-decorator'
import { ElCarousel } from 'element-ui/types/carousel'
import XLSX from 'xlsx'
import { ElPopover } from 'element-ui/types/popover'
import { ElButton } from 'element-ui/types/button'

import { Product, CartItem } from '@/interfaces/product'
import Page from '@/components/Page.vue'

const BaseVue = Vue.extend({
  components: {
    Page
  },
  computed: {
    ...mapState(['totalPages', 'currentPageIndex']),
    ...mapGetters(['inMobilePages'])
  },
  methods: {
    ...mapMutations(['setCurrentPageIndex'])
  }
})

@Component
export default class Catalogue extends BaseVue {
  carouselWidth = 0
  carouselHeight = 0

  mounted () {
    this._detectSwipeGestures()
    this._calcCarouseSizes()
  }

  private _detectSwipeGestures () {
    const catalogueCarousel = this.$refs.catalogueCarousel as ElCarousel
    const hammer = new Hammer(catalogueCarousel.$el as HTMLDivElement)

    hammer.on('swipeleft', () => {
      catalogueCarousel.next()
    })

    hammer.on('swiperight', () => {
      catalogueCarousel.prev()
    })
  }

  private _calcCarouseSizes () {
    const IMAGE_HEIGHT = 794
    const $catalogue = this.$el as HTMLDivElement

    const computeCarouselSizes = () => {
      const IMAGE_WIDTH = 609 * (window.innerWidth <= 800 ? 1 : 2)
      const { clientWidth, clientHeight } = $catalogue
      const catalogueWidth = clientWidth - (window.innerWidth <= 800 ? 20 : 120)
      const catalogueHeight = clientHeight - 20

      const calculatedHeight = IMAGE_HEIGHT * catalogueWidth / IMAGE_WIDTH

      if (calculatedHeight > catalogueHeight) {
        this.carouselWidth = IMAGE_WIDTH * catalogueHeight / IMAGE_HEIGHT
        this.carouselHeight = catalogueHeight
      } else {
        this.carouselWidth = catalogueWidth
        this.carouselHeight = calculatedHeight
      }
    }

    computeCarouselSizes()
    window.addEventListener('resize', computeCarouselSizes)
  }

  @Watch('currentPageIndex')
  onPageIndexChange (newPageIndex: number, oldPageIndex: number) {
    const catalogueCarousel = this.$refs.catalogueCarousel as ElCarousel

    if (oldPageIndex - 1 === newPageIndex) {
      if ((catalogueCarousel as any).activeIndex !== newPageIndex) {
        catalogueCarousel.prev()
      }
    } else if (oldPageIndex + 1 === newPageIndex) {
      if ((catalogueCarousel as any).activeIndex !== newPageIndex) {
        catalogueCarousel.next()
      }
    } else {
      catalogueCarousel.setActiveItem(newPageIndex)
    }
  }

  onIndexChange (index: number) {
    this.setCurrentPageIndex(index)
  }
}
